import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Alert, Button, Col, Modal, Row } from 'react-bootstrap';
import ManifestsTable from '../../../../manifests/manifestsList/components/ManifestsTable';
import ManifestSearch from '../../../../manifests/manifestsList/components/ManifestSearch';
import {
    clearManifests,
    getIsFetching,
    getManifests,
    INITIAL_MANIFEST_SEARCH_FORM,
    loadManifests,
} from '../../../../manifests/duck';
import { connect } from 'react-redux';
import update from 'immutability-helper';
import moment from 'moment';
import { linkSmaEma, silentFetchAbnormalityAnalysis } from '../../../analysisDuck';

class EmaSmaModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            search: INITIAL_MANIFEST_SEARCH_FORM,
            selectedEmaManifestId: '',
            emaError: null,
            showEpsDownload : false,
        };
    }

    handleChange = e => {
        const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
        const newSearch = update(this.state.search, {
            [e.target.name]: { $set: value },
        });
        this.setState({ search: newSearch });
    };

    handleDateChange = field => date => {
        const newSearch = update(this.state.search, {
            [field]: {
                $set: date,
            },
        });
        this.setState({ search: newSearch });
    };

    handleCheckSelect = row => {
        this.setState(() => ({
            selectedEmaManifestId: row.manifestId,
            emaError: null,
        }));
    };

    handleHideModal = () => {
        this.setState(() => ({
            selectedEmaManifestId: '',
            emaError: null,
        }));
        this.props.hideEmaModal();
    };

    handleConfirmSelection = () => {
        if (this.state.selectedEmaManifestId === '') {
            this.setState(() => ({
                emaError: 'Please select a manifest.',
            }));
        } else {
            this.setState(() => ({
                emaError: null,
            }));
            this.props
                .linkSmaEma(this.props.selectedManifestId, this.state.selectedEmaManifestId)
                .then(() => {
                    this.handleHideModal();
                    //TODO: needs to be a sse triggered refetch instead of a manually delayed one...
                    this.props.silentFetchAbnormalityAnalysis(this.props.abnormalityId);
                });
        }
    };

    handleReset = () => {
        this.props.clearManifests();
        this.setState(() => ({
            search: INITIAL_MANIFEST_SEARCH_FORM,
        }));
    };

    handleSubmit = e => {
        e.preventDefault();
        const preparedForm = this.prepareFormDataForPost(this.state.search);
        this.props.loadManifests(preparedForm);
    };

    prepareFormDataForPost = form => {
        return update(form, {
            runDate: {
                $set: form.runDate ? moment(form.runDate).format('YYYY-MM-DD') : '',
            },
            pLaneExit: {
                $set: form.pLaneExit ? moment(form.pLaneExit).toISOString() : '',
            },
            connectingRunTime: {
                $set: form.connectingRunTime ? moment(form.connectingRunTime).toISOString() : '',
            },
        });
    };

    render() {
        const { showEmaModal, isFetching, manifests } = this.props;
        const { search, emaError, showEpsDownload } = this.state;
        return (
            <Modal show={showEmaModal} onHide={this.handleHideModal} bsSize="large">
                <Modal.Header>
                    <Modal.Title>Search EMA/SMA Manifest</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div>
                        <Row>
                            <Col xs={12}>
                                <ManifestSearch
                                    handleChange={this.handleChange}
                                    handleDateChange={this.handleDateChange}
                                    handleSubmit={this.handleSubmit}
                                    handleReset={this.handleReset}
                                    search={search}
                                    isFetching={isFetching}
                                    showEpsDownload={showEpsDownload}
                                />
                            </Col>
                        </Row>
                        {emaError && (
                            <Row>
                                <Col xs={12}>
                                    <Alert bsStyle={'danger'}>{emaError}</Alert>
                                </Col>
                            </Row>
                        )}
                        <Row>
                            <Col xs={12}>
                                <ManifestsTable
                                    isSelectable
                                    isRadioSelect
                                    onCheckSelect={this.handleCheckSelect}
                                    manifests={manifests}
                                    isFetching={isFetching}
                                    search={search}
                                />
                            </Col>
                        </Row>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        className="pull-right"
                        style={{ marginRight: 20 }}
                        bsStyle="success"
                        onClick={this.handleConfirmSelection}
                    >
                        Confirm Selection
                    </Button>
                    <Button
                        className="pull-right"
                        style={{ marginRight: 20 }}
                        bsStyle="default"
                        onClick={this.handleHideModal}
                    >
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }
}

EmaSmaModal.propTypes = {
    showEmaModal: PropTypes.bool,
    selectedManifestId: PropTypes.string,
    hideEmaModal: PropTypes.func,
    abnormalityId: PropTypes.string,
};
EmaSmaModal.defaultProps = {
    showEmaModal: false,
};

export default connect(
    state => ({
        manifests: getManifests(state),
        isFetching: getIsFetching(state),
    }),
    {
        loadManifests,
        clearManifests,
        linkSmaEma,
        silentFetchAbnormalityAnalysis,
    }
)(EmaSmaModal);
